import React, { useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { getBaseUrl } from '../common/BaseUrl';

const TwitterCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useParams(); // This will be undefined if there's no token in the URL
  
  const queryParams = new URLSearchParams(location.search);
  const error = queryParams.get('error'); // Get error query parameter
  
  let base_url = getBaseUrl();
  
  console.log(token, "token", error);

  useEffect(() => {
    if (error) {
      console.error('Login Failed');
      navigate(`${base_url}login`);
    } else if (token) {
      localStorage.setItem("token", token);
        navigate(`${base_url}userdashboard`
          , {
            state: { from: "real_account" },
          }
        );
    } else {
      console.error('Missing token');
      navigate(`${base_url}login`);
    }
  }, [navigate, token, error, base_url]);

  return <div>Processing Twitter login...</div>;
};

export default TwitterCallback;
